import PreviewDocRow from './PreviewDocRow.component';

export default PreviewDocRow;
